export default function RcmpArrowDownSingleAccordion(props) {
  return (
    <svg
      width="16"
      height="9"
      viewBox="0 0 16 9"
      fill={props.fill || "#415364"}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M15.7256 1.53087L8.61458 8.34496C8.44329 8.51048 8.22106 8.59267 7.99999 8.59267C7.77891 8.59267 7.55673 8.51048 7.38543 8.34496L0.274374 1.53087C-0.0809608 1.1919 -0.0925534 0.629383 0.247744 0.275234C0.585708 -0.0812486 1.15052 -0.092841 1.50353 0.248604L7.99999 6.47259L14.4965 0.248604C14.8483 -0.092841 15.4143 -0.0812486 15.7523 0.275234C16.0925 0.629383 16.081 1.1919 15.7256 1.53087Z" />
    </svg>
  )
}
